import React from 'react';
import WhatsAppMobilePage from './WhatsAppMobilePage';

const WhatsAppMobileConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/apps/whatsapp',
			component: WhatsAppMobilePage
		}
	]
};

export default WhatsAppMobileConfig;
